import styled from "styled-components";
import { config } from '../config';

const Style = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;

  .settings-icon svg {
    color: var(--base-gray-70);
  }

  .content {
    width: 100%;
    flex: 1;
    overflow: auto;
    display: flex;

    .view-content {
      flex: 1;
      overflow: auto;
      padding: var(--size-lg);
      background: ${config.DASHBOARD_BACKGROUND};
      display: flex;
      flex-direction: column;
      gap: var(--size-lg);
      padding: var(--size-lg);

      section {
        display: flex;
        gap: var(--size-lg);
      }
    }
  }
`;

export default function DashboardLayout({ children }) {
  return (
    <Style>{children}</Style>
  );
}
